
import { IFormInputText } from '../../types'
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator'
import { TranslationHandler } from '../../mixins/translation-handler'
import intlTelInput from 'intl-tel-input'
import cms from '@/cms'

@Component({
})
export default class InputText extends Mixins(TranslationHandler) {
  @Prop() input!: IFormInputText
  @Prop() value!: string
  @Prop() isErrorShown!: boolean

  $refs!: {
    tel: HTMLInputElement;
  }

  intlTelInput: any

  day = ''
  month = ''

  get isDayMonthBirthdate (): boolean {
    return this.input.data.type === 'birthdate' && !!this.input.data.dayMonthOnly
  }

  get daysInSelectedMonth (): number {
    // Feb always allows 29 (year 1200 is a leap year). Other months: standard lengths.
    const thirty = new Set(['04', '06', '09', '11'])
    if (this.month === '02') return 29
    if (thirty.has(this.month)) return 30
    return 31
  }

  get dayOptions (): string[] {
    return Array.from({ length: this.daysInSelectedMonth }, (_, i) => String(i + 1).padStart(2, '0'))
  }

  get monthOptions (): { value: string; label: string }[] {
    const fmt = new Intl.DateTimeFormat(this.$tLocaleCurrent, { month: 'long' })
    return Array.from({ length: 12 }, (_, i) => ({
      value: String(i + 1).padStart(2, '0'),
      // Day 15 avoids DST/timezone edges; only the month name is used
      label: fmt.format(new Date(Date.UTC(2021, i, 15))),
    }))
  }

  @Watch('month')
  clampDayToMonth () {
    if (this.day && Number(this.day) > this.daysInSelectedMonth) {
      this.day = ''
    }
  }

  @Watch('day')
  @Watch('month')
  syncDayMonth () {
    if (!this.isDayMonthBirthdate) return
    if (this.day && this.month) {
      // Year fixed to 1200 (a fake leap year) so the ISO date validates in external services
      this._value = `1200-${this.month}-${this.day}`
    } else {
      this._value = ''
    }
  }

  mounted () {
    // Prefill day/month from existing value (e.g. "1200-MM-DD") when dayMonthOnly
    if (this.isDayMonthBirthdate && this.value) {
      const match = /^\d{4}-(\d{2})-(\d{2})$/.exec(this.value)
      if (match) {
        this.month = match[1]
        this.day = match[2]
      }
    }

    // if type is tel, initialize intlTelInput
    if (this.input.data.type === 'telephone') {
      this.intlTelInput = intlTelInput(this.$refs.tel, {
        initialCountry: this.input.data?.preSelect?.toLocaleLowerCase() || cms.i18n.userCountryCode?.toLocaleLowerCase() || 'de',
        // @ts-ignore
        loadUtils: () => import('intl-tel-input/utils'),
      })

      // listen to 'keyup', but also 'change' to update when the user selects a country
      this.$refs.tel.addEventListener('change', this.handleTelChange)
      this.$refs.tel.addEventListener('keyup', this.handleTelChange)
    }
  }

  handleTelChange () {
    this._value = this.intlTelInput.getNumber()
  }

  get translations (): IFormInputText['data']['messages'][0] {
    return {
      label: this.$tx(this.input.data.messages, 'label'),
      error: this.$tx(this.input.data.messages, 'error'),
      placeholder: this.$tx(this.input.data.messages, 'placeholder'),
    }
  }

  get _value (): string {
    return this.value
  }

  set _value (data: string) {
    this.$emit('input', data)
  }

  get todayStr (): string {
    return new Date().toISOString().split('T')[0]
  }

  get cssVars () {
    return {
      '--bg-color': this.input.data.background,
      '--text-color': this.input.data.textColor
    }
  }

  borderRadius = {
    medium: 'rounded-md',
    none: '',
    full: 'rounded-3xl'
  }
}
